package landing.model.state

import androidx.compose.runtime.Immutable


@Immutable
data class SloganPagerState(
    val initialPage: Int = 0,
    val nextPage: Int = -1
)
